import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Don't show breadcrumbs on home page
  if (pathnames.length === 0) {
    return null;
  }

  const formatBreadcrumb = (str) => {
    // Handle service IDs and common URL patterns
    return str
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <nav className="bg-slate-50 border-b border-slate-200 py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center space-x-2 text-sm">
          <li>
            <Link
              to="/"
              className="flex items-center text-slate-600 hover:text-primary transition-colors"
              data-testid="breadcrumb-home"
            >
              <Home className="w-4 h-4" />
            </Link>
          </li>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;

            return (
              <li key={name} className="flex items-center">
                <ChevronRight className="w-4 h-4 text-slate-400 mx-2" />
                {isLast ? (
                  <span className="text-slate-900 font-medium">
                    {formatBreadcrumb(name)}
                  </span>
                ) : (
                  <Link
                    to={routeTo}
                    className="text-slate-600 hover:text-primary transition-colors"
                    data-testid={`breadcrumb-${name}`}
                  >
                    {formatBreadcrumb(name)}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}
